import { capitalize, colors } from "@mui/material";
import { bottom, left } from "@popperjs/core";

//mui styles
export const formStyle = {
    width: '100%',
    margin: '0 auto',
    padding: '20px',
    border: '1px solid #ccc',
    borderRadius: '5px',
};

export const stepNumberStyle = {
    width: '55px',
    height: '55px',
    borderRadius: '50%',
    backgroundColor: '#6f42c1',
    color: '#fff',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '18px',
    fontWeight: 'bold',
    marginRight: '1.5rem',
};

export const topUnderlineStyle = {
    borderBottom: '4px solid #6f42c1',
    marginBottom: '20px',
}

export const underlineStyle = {
    borderBottom: '1px solid #6f42c1',
    marginBottom: '20px',
};

export const formTitleStyle = {
    fontSize: '1.2rem',
    margin: '0',
    fontWeight: '900',
    color: '#6f42c1',
    textAlign: 'start'
}

export const formDesStyle = {
    margin: '0',
    textAlign: 'start',
    color: '#6f42c1',
}

export const typographyStyle = { 
    textAlign: 'left', 
    marginBottom: '8px', 
    fontSize: '12px'
}

export const typographyTitleStyle = { 
    textAlign: 'left', 
    marginBottom: '8px', 
    fontSize: '16px',
    fontStyle: 'bold'
}

export const defaultLabel = {
    textAlign: 'start'
}

export const pdapNotice = {
    fontWeight: 'bold',
    fontStyle: 'italic',
    color: '#5F5395',
    fontSize: '0.9rem',
    textTransform: 'uppercase',
    textAlign: 'start',
    margin: '5px 0'
};

export const lastStepTitle = {
    color: '#5A46AA',
    fontSize: '1.2rem',
    margin: '5px 0',
    fontWeight: 'bold',
    textAlign: 'start'
}

export const lastStepDesc = {
    fontSize: '0.8rem',
    textAlign: 'start'
}

export const fieldDataStyle = {
    fontWeight: 'bold'
}

export const titleLabel = {
    textAlign: 'start',
    fontWeight: 'bold',
    marginBottom: '12px'
}

export const smallLabel = {
    textAlign: 'start', 
    fontSize: '16px',
}

export const subSection = {
    textAlign: 'start', 
    fontSize: '12px',
    marginLeft: '16px'
}

export const typographySpanStyle = {
    display: 'inline-block', 
    marginRight: '6px'
}

export const sectionContainer = {
    marginBottom: '20px',
    marginTop: '20px'
}